function formatToReal(valor) {
  if (valor === null || valor === undefined || isNaN(valor)) {
    return "R$ 0,00";  
  }
 
  return valor.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
 
export default formatToReal;